import { notification } from 'antd';
import { useEffect, useState } from 'react';

import apiDatalake from '../../../../services/apiDatalake';

const useMedidaPeriodoData = ({ filters, clientes }) => {
  const [medidaPeriodoData, setMedidaPeriodoData] = useState([]);
  const [loadingMedidaPeriodoData, setLoadingMedidaPeriodoData] = useState(
    false
  );

  useEffect(() => {
    const getMedidaPeriodoData = async () => {
      if (!clientes) {
        return;
      }

      setLoadingMedidaPeriodoData(true);
      try {
        if (filters?.periodo !== null) {
          const { data } = await apiDatalake.post(
            'buscar-medida-dinamica-periodo-shipper',
            {
              cpf_cnpj_cliente: clientes,
              ...(filters.periodo[0] && {
                data_inicial: filters.periodo[0].toDate(),
              }),
              ...(filters.periodo[1] && {
                data_final: filters.periodo[1].toDate(),
              }),
              ...(filters.produto &&
                filters.produto?.value !== 'Todos' && {
                  produto: filters.produto.value,
                }),
              ...(filters.cidade &&
                filters.cidade?.value !== 'Todas' && {
                  cidade: filters.cidade.value,
                }),
              ...(filters.estado &&
                filters.estado?.value !== 'Todos' && {
                  estado: filters.estado.value,
                }),
            }
          );

          if (data) {
            setMedidaPeriodoData(data.lista_periodos);
          }
        }
      } catch {
        notification.error({
          message: 'Não foi possível obter os dados de periodo',
          description: 'Tente novamente ou entre em contato com o suporte',
        });
      }
      setLoadingMedidaPeriodoData(false);
    };
    getMedidaPeriodoData();
  }, [
    filters.periodo,
    filters.produto,
    filters.cidade,
    filters.estado,
    clientes,
  ]);

  return {
    medidaPeriodoData,
    loadingMedidaPeriodoData,
  };
};

export default useMedidaPeriodoData;
